import script from "./data-security-zone.vue?vue&type=script&lang=ts&setup=true"
export * from "./data-security-zone.vue?vue&type=script&lang=ts&setup=true"

import "./data-security-zone.vue?vue&type=style&index=0&id=456d6e94&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456d6e94"]])

export default __exports__